export class TextHelper {
    /**
     * Get a page title by combining the provided title and application name.
     */
    static getPageTitle(title, appName, appReleaseDesignation) {
        if (!appName)
            return title;
        if (appReleaseDesignation)
            return `${appReleaseDesignation} | ${appName} - ${title}`;
        return `${appName} - ${title}`;
    }
    /**
     * Get record title by combining it's name and status.
     */
    static getRecordTitle(recordName, isArchived) {
        return `${recordName}${isArchived ? " (Archived)" : ""}`;
    }
    /**
     * Format numeric status field by restricting the value to a given limit.
     * E.g. Will return 100+ when input is 1000 and maxItems is 100.
     */
    static formatNumericStatusField(input, maxItems) {
        if (!input)
            return "0";
        return input > maxItems ? `${maxItems.toString()}+` : input.toString();
    }
    static stripHtml(input) {
        if (!input)
            return "";
        return input.toString().replace(this.htmlRegex, "");
    }
}
TextHelper.htmlRegex = /<[^>]+>/g;
TextHelper.emptyListItemName = "Please select an option";
